import { useState, useContext, useEffect } from 'react'
import { useTranslation } from "react-i18next";
import { Link, useLocation } from 'react-router-dom';

import { MdHourglassTop, MdOutlineHourglassBottom, MdOutlineTimer, MdFormatListBulleted, MdReadMore, MdOutlineContentCopy, MdOutlineRemoveRedEye, MdEdit, MdDeleteOutline } from "react-icons/md";
import { IoEllipsisVertical, IoSchoolOutline } from "react-icons/io5";
import { BsFiletypeXls } from "react-icons/bs";
import { SiGoogleclassroom } from "react-icons/si";

import { AppContext } from "../../../Context";
import { Img } from "../../../components/Elements"; 
import Fetch, { Loader, DateToText, ClassToName } from "../../../inc/Fetch"; 
import GoogleShareToClassRoom from '../../../components/classRomm';
import { TbBrandTeams } from 'react-icons/tb';

export default function Task({ v, noMenu, tag, game }) {

    const { t } = useTranslation();
    const location = useLocation();
    const { successData, userData } = useContext(AppContext);
    const [open, setopen] = successData;
    const [userinfo, setuserinfo] = userData;
    
    const [loader, setloader] = useState(false);
    const [copy, setcopy] = useState(false);
    const [del, setdel] = useState(false);
    const [menuOpen, setmenuOpen] = useState(false);

    function copyUrl(url) {

        navigator.clipboard.writeText(url);
        setcopy(true);
        setTimeout(() => {
            setcopy(false);
        }, 2000);
    }

    function deleteTask(id) {

        const conf = window.confirm(t("error",  { returnObjects: true })[2]);
        if (!conf) {
            return false;
        }

        setloader(true);

        Fetch("task/deleteTask", (d) => {

            if (d?.error) {
                setopen({ error:true, short: t("error",  { returnObjects: true })[d?.error] });
            } else {
                setdel(true);
            }
            
            setloader(false);
        }, { _id: id });
    }

    function shareClassRoom(link, title) {
        const url = `https://classroom.google.com/share?url=${encodeURIComponent(link)}&title=${encodeURIComponent(title)}`;
        window.open(url, "_blank");
    }

    function shareTeams(link, title) {
        const url = `https://teams.microsoft.com/share?href=${encodeURIComponent(link)}&text=${encodeURIComponent(title)}`;
        window.open(url, "_blank");
    }



    useEffect(() => {

        const closeFunc = (e) => {
            const selClose = e?.target.closest(".taskMenuBox");
            if (!selClose) {
                setmenuOpen(false)
            }
        }

        window.addEventListener("click", closeFunc);
        return () =>{
            window.removeEventListener("click", closeFunc);
        }
        

    }, []);

    if (del) {
        return false;
    }


    return (
        <div className='taskClassesBox'>
            <Img src={`img/100/${v?.task?.img}`} /> 
            
            <Link className='midFlex' to={userinfo?.userlevel >= 3 ? `/myTasks/${v?._id}` : `/task/start/${v?._id}`}>
                <p>
                    <h3>{v?.title}</h3>
                    <h4>{v?.task?.cat?.name} - <DateToText time={v?.date} /></h4>
                    <text>{v?.story?.replace(/(<([^>]+)>)/gi, " ")?.substring(0, 200)}</text>
                </p>

                <ul className='taskInfoUl'>
                    {/* <li style={{backgroundColor:"#ffb53a", color:"#000", padding:"2px 10px"}}>{t("class")} <ClassToName classes={v?.classes} /></li> */}
                    <li><MdHourglassTop />{v?.start_date ? <DateToText time={v?.start_date} />: t("no_value")}</li>
                    <li><MdOutlineHourglassBottom /> {v?.end_date ? <DateToText time={v?.end_date} />: t("no_value")}</li>
                    {v?.timer?.name ? <li><MdOutlineTimer /> {v?.timer?.name}</li>: false}
                    {v?.questions?.length ? <li><MdFormatListBulleted /> {t("tasks_send_op_1")} ({v?.questions?.length})</li>: false}
                    {v?.answersQnt ? <li className='tag blue'><IoSchoolOutline /> {t("participant")} ({v?.answersQnt})</li>: false}
                    {v?.answersQnt ? <li className='tag green'><IoSchoolOutline /> {t("avg")} ({v?.answersQnt})</li>: false}
                    {v?.students?.length ? <li className='tag green'><IoSchoolOutline /> {t("students_tasks_number", { num: v?.students?.length })}</li>: false}
                </ul>
            </Link>

            {userinfo?.userlevel < 3 && 
                <div className={`taskAnswerStBox ${v?.answers?.score && v?.answers?.status && "bord"}`}>
                    {!v?.answers?.status && <span className='tag'>{t("task_student_status_0")}</span>}
                    {v?.answers?.status == 1 && <span className='tag orange'>{t("task_student_status_1")}</span>}
                    {v?.answers?.status == 2 && <span className='tag blue'>{t("task_student_status_2")}</span>}

                    {v?.answers?.score !== false && v?.answers?.status > 1 && <b>{v?.answers?.score}%</b>}
                </div>
            }

            {!noMenu && 
            <>
                {userinfo?.userlevel >= 3 && <nav className='taskMenuBox'>
                    {copy && <div className='copyBox'>{t("tasks_copy_success")}</div>}
                    <a onClick={() => setmenuOpen(r => !r)} className='mainDotesMenu'><IoEllipsisVertical /></a>
                    
                    <ul className={menuOpen ? "open" : "closed"}>
                        <div>
                            <Link className='mLink' target='_blank' to={`/taskStatsDownload/${v?._id}`} ><BsFiletypeXls /><b>{t("tasks_menu_7")}</b></Link>
                            <Link className='mLink' to={`/myTasks/${v?._id}`}><MdReadMore /><b>{t("tasks_menu_1")}</b></Link>
                            <Link className='mLink' to={`/task/start/${v?._id}`}><MdOutlineRemoveRedEye /><b>{t("tasks_menu_2")}</b></Link>
                            <Link className='mLink' to={`/sendTask/${v?.task?._id}/${v?._id}`} state={{ previousLocation: location }}><MdEdit /><b>{t("tasks_menu_3")}</b></Link>
                            <a onClick={() => shareClassRoom(`https://www.yallangany.com/task/start/${v?._id}`, v?.title)} className='mLink'>
                                <SiGoogleclassroom />
                                <b>{t("tasks_menu_4")}</b>
                            </a>

                            <a onClick={() => shareTeams(`https://www.yallangany.com/task/start/${v?._id}`, v?.title)} className='mLink'>
                                {/* <div
                                    className="teams-share-button"
                                    data-href={`https://www.yallangany.com/task/start/${v?._id}`}
                                    data-msg-text={v?.title}
                                    data-assign-title={v?.story?.replace(/(<([^>]+)>)/gi, " ")?.substring(0, 200)}
                                > */}
                                <TbBrandTeams />
                                <b>{t("tasks_menu_5")}</b>
                            </a>
                            <a onClick={() => copyUrl(`https://www.yallangany.com/task/start/${v?._id}`)} className='mLink'><MdOutlineContentCopy /><b>{t("tasks_menu_6")}</b></a>
                            <a onClick={() => deleteTask(v?._id)} className='mLink'><MdDeleteOutline /><b>{t("delete")}</b></a>
                        
                        </div>
                        
                    </ul>
                </nav>}
            </>}
            
        </div>
    )
}
